import { Divider, Modal } from "antd";
import React, { useState } from "react";
import { upperCase } from "../../libs";

function Transfer({ props }) {
  const { isSucces, onClose, onMove, dataTransfer } = props;

  const [isShow, setShow] = useState(true);

  return (
    <Modal
      title={null}
      visible={isSucces}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={dataTransfer.payment_method_id !== 2 ? 400 : 420}
    >
      <div>
        <p className="colors-blue text-2xl mb-3 font-bold header-title-bold ">
          Pesanan Sukses
        </p>
        <div className="flex justify-center mt-5 ">
          <img
            src={
              process.env.REACT_APP_BASE_URL + "/assets/icon/ic_checkout.svg"
            }
            alt="icon-checkout"
            className="w-50"
          />
        </div>
        <div className=" flex justify-center">
          <p className="text-center mt-3 w-3/4 lg:w-2/3">
            Pesanan anda telah sukses silahkan melakukan pembayaran{" "}
            {dataTransfer.payment_method_id === 1 && "tunai di tempat"}
          </p>
        </div>

        {dataTransfer.payment_method_id !== 1 && (
          <div>
            <Divider />
            <div>
              <div className="flex mb-3 justify-between ">
                <p className="header-content colors-gray text-sm lg:text-md">
                  Metode Pembayaran
                </p>
                <p className="header-content colors-blue text-sm lg:text-md font-semibold">
                  {dataTransfer?.payment_method ?? "Transfer"}
                </p>
              </div>
              {dataTransfer.payment_method_id !== 3 && (
                <div>
                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-md">
                      Bank
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-md font-semibold">
                      {upperCase(dataTransfer?.transfer_bank ?? "Bank Mandiri")}
                    </p>
                  </div>

                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-md">
                      Nomor Rekening
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-md font-semibold">
                      {dataTransfer?.transfer_account ?? "Tidak Ada Nomor"}
                    </p>
                  </div>

                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      Nama Rekening
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                      {upperCase(
                        dataTransfer?.transfer_name ?? "Tidak Ada Nama"
                      )}
                    </p>
                  </div>
                </div>
              )}

              {dataTransfer.payment_method_id === 3 && (
                <div>
                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-md">
                      QRIS QR Code
                    </p>
                    <p
                      onClick={() => setShow(!isShow)}
                      className="cursor-pointer header-content colors-blue text-sm lg:text-md font-semibold"
                    >
                      {isShow ? "Sembunyikan" : "Tampilkan"}
                    </p>
                  </div>
                  {isShow && (
                    <div>
                      <p className="text-center header-content colors-blue text-md lg:text-2xl mt-4 font-semibold">
                        QRIS QR Code
                      </p>
                      <div className="flex justify-center">
                        <img
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/image/img_empty.png"; // some replacement image
                          }}
                          src={
                            process.env.REACT_APP_BACKEND_URL +
                            "/storage/" +
                            dataTransfer.transfer_link
                          }
                          alt="img-media"
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        <div>
          <button
            onClick={onMove}
            className="btn-blue w-full p-3 mt-8 focus:outline-none"
          >
            <div className="text-white lg:text-lg">Konfirmasi Pembayaran</div>
          </button>
          <p
            onClick={onClose}
            className="text-center mt-5 cursor-pointer colors-gray font-semibold text-base"
          >
            Tutup
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Transfer;
